<template>
  <div>
    <Header />
    <Body />
    <Footer />
  </div>
</template>

<script>
/* eslint-disable */
/*componenti*/
import Header from '@/components/views/Header.vue'
import Body from '@/components/views/About.vue'
import Footer from '@/components/views/Footer.vue'

export default {
  name: 'ChiSiamo',
  components: {
    Header,
    Body,
    Footer
  },
}
</script>
